import React, { PropTypes, Component } from 'react';
import Carousel from 'react-slick';
import ProjectTile from 'common/components/project_tile';
import { v4 } from 'node-uuid';
import {RightNavButton, LeftNavButton} from 'common/components/carousel_controls';

const CompletedProjects = ({ is_client, completedProjects, categories, user }) => {

  if (!is_client || !completedProjects || !completedProjects.length) {
    return null;
  }

  const settings = {
    className: 'carousel row',
    dots: false,
    nextArrow: <RightNavButton />,
    prevArrow: <LeftNavButton />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // handle missing window obj when server-rendering
  const style = {maxWidth: typeof window != "undefined"? window.innerWidth : 0}

  return (<div className="profile-completed-projects" style={style}>
    <div className="row">
      <h2 className="small-16 columns">Completed Projects</h2>
    </div>
    <Carousel {...settings}>
      { completedProjects.map(item => (
        <div key={v4()} className="small-16 columns">
          <ProjectTile
            item={item}
            titleTag="h3"
            categories={categories}
            authenticated={user.logged_in}
            userType={user.profile_data ? user.profile_data.user_type : 'Anonymous'}
          />
        </div>
      ))}
    </Carousel>
  </div>);
}

CompletedProjects.propTypes = {
  is_client: PropTypes.bool,
  completedProjects: PropTypes.array,
  categories: PropTypes.array,
  user: PropTypes.object,
};

export default CompletedProjects;



// WEBPACK FOOTER //
// ./profile/components/completed_projects.jsx